import React from 'react';
import { MARCAS, setMarcaActiva } from '../engine/marcas';

// Hash explícito con marca SIEMPRE (incluido mbm) para no heredar la última marca guardada.
const hashVistaMarca = (vista, id) => `#${vista}&marca-${id}`;

// Cabecera B2B2C: conmutador de vista + selector de entidad (marca).
export const BrandSwitcher = ({ marca, vista }) => {
  const irVista = (v) => { setMarcaActiva(marca.id); window.location.hash = hashVistaMarca(v, marca.id); };
  const cambiarMarca = (id) => { setMarcaActiva(id); window.location.hash = hashVistaMarca(vista, id); };

  return (
    <header className="b2b-head" style={{ '--marca': marca.color }} data-testid="b2b-header">
      <div className="b2b-brand">
        {marca.id === 'mbm' ? (
          <img src="/mbm-logo.svg" alt="MBM" width={30} height={30} data-testid="b2b-logo" />
        ) : (
          <span className="b2b-mono" style={{ background: marca.color }} data-testid="b2b-mono">{marca.mono}</span>
        )}
        <strong data-testid="b2b-marca-nombre">{marca.nombre}</strong>
      </div>

      <div className="b2b-switch" role="tablist" aria-label="Vista">
        <button
          type="button"
          className={vista === 'sitio' ? 'on' : ''}
          onClick={() => irVista('sitio')}
          data-testid="switch-sitio"
        >
          Sitio del cliente
        </button>
        <button
          type="button"
          className={vista === 'corredor' ? 'on' : ''}
          onClick={() => irVista('corredor')}
          data-testid="switch-corredor"
        >
          Vista del corredor
        </button>
      </div>

      <label className="b2b-entidad">
        <span>Entidad</span>
        <select
          value={marca.id}
          onChange={(e) => cambiarMarca(e.target.value)}
          data-testid="entidad-select"
        >
          {Object.values(MARCAS).map((m) => (
            <option key={m.id} value={m.id}>{m.nombre}</option>
          ))}
        </select>
      </label>
    </header>
  );
};
